export const PhoneNo = "0321-5570337";
export const WhatsApp = "+923215570337";
export const Email = "support@.pk";
export const Address = `Address: Flat No 1, 1st floor plot No 38, Block-A, MPCHS sector B-17, Islamabad`;

export const FacebookAccountURL = "https://www.facebook.com/nutraprimepk/";
